import api from '../../../api'
import _ from 'lodash'
import axios from 'axios';

export default {
    getSubscriptions : (payload, next) => {
        api.get('/stripe/subscriptions?customer=' + payload.query.userId, (err, data) => {
            if(err) return next(err, null);

            next(null, data);
        })   
    },
    getExternalSubscriptions : (payload, next) => {
        axios.post('https://www.juphy.com/uh19d281d798/subs', payload.body)
          .then(function (response) {
            next(null, response.data);
          })
          .catch(function (err) {
            if(err) return next(err, null);
          });
    }
} 



// WEBPACK FOOTER //
// ./src/libs/system/services/subscriptions.js